<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <notifications position="top left" animation-type="velocity"/>
                <div class="header">
                    <div class="title">
                        <h1>
                            Instagram Banned Hashtags Tool by
                            <a href="/" target="_blank">RiteTag</a>
                        </h1>
                    </div>
                    <div class="description">
                        <h4>Remove banned hashtags before posting to Instagram:</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-md-offset-3">
                <div class="content-area">
                    <textarea class="form-control" v-model="hashtagsArea" rows="4"></textarea>
                    <div class="buttons">
                        <button @click="enhance" class="btn btn-primary">
                            <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                            <i v-else class="fa fa-trash-o"></i>
                            Banned Hashtags
                        </button>
                        <button
                            class="btn btn-default"
                            v-clipboard:copy="hashtagsArea"
                            v-clipboard:success="hashtagsCopied"
                        >
                            <i class="fa fa-copy"></i>
                            Copy
                        </button>
                        <button @click="clear" class="btn btn-default">
                            <i class="fa fa-undo"></i>
                            Clear
                        </button>
                    </div>
                    <div class="alert alert-success" v-if="hashtagsEnhanced">
                        <p>{{removedHashtags}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="tired-warning">
            <h2>Tired of removing banned hashtags?</h2>
            <h4>Get Instagram ready hashtag suggestions for your images and text.</h4>
            <br>
        </div>
    </div>
</template>
<script>
/* eslint-disable handle-callback-err */
import axios from 'axios'
export default {
    name: 'banned-instagram',
    data () {
        return {
            hashtagsArea: '#instaphotography #instabeauty #instagirls #girlsofinstagram #instanature #instagirl #photography #beauty #girls #nature #girl #sky #water #balls #lady #ladies #woman #women #photograph #photographs #beauties #sunlight #sitting #waters #skies #sit #photographies',
            removedHashtags: '',
            loading: false,
            hashtagsEnhanced: false
        }
    },
    methods: {
        enhance () {
            this.loading = true

            const params = new URLSearchParams()
            params.append('post', this.hashtagsArea)

            axios.post('/instagram/blacklist', params)
                .then((response) => {
                    this.loading = false
                    console.log(response.data)
                    this.setRemovedHashtags(response.data.bannedHashtags)
                    this.hashtagsArea = response.data.post
                }).catch(error => {
                    this.loading = false
                    this.setRemovedHashtags([])
                })
        },
        clear () {
            this.hashtagsArea = ''
        },
        hashtagsCopied () {
            this.$notify({ type: 'success', text: 'Hashtags Copied' })
        },
        setRemovedHashtags (bannedHashtags) {
            this.hashtagsEnhanced = true
            this.removedHashtags = ''
            if (bannedHashtags.length === 0) {
                this.removedHashtags += 'No hashtags are banned!'
                return
            }

            this.removedHashtags = ''
            bannedHashtags.forEach(h => {
                this.removedHashtags += `${h} `
            })
            if (bannedHashtags.length === 1) {
                this.removedHashtags += 'is banned on instagram and was removed.'
            } else {
                this.removedHashtags += 'are banned on instagram and were removed.'
            }
        }
    }
}
</script>

<style scoped>
.header {
    text-align: center;
}
.tired-warning {
    text-align: center;
}
.buttons {
    margin-top: 0.5em;
}
.alert.alert-success {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/BannedInstagram.vue